import {CommonsConstantsType} from '../../../../constants/ib-commons-constants';

@Component('ib-ui-expiry-dates-select-module', 'ibUiExpiryDatesSelect', {
    bindings: {
        showDay: '<?',
        maximumYears: '<?',
        day: '=?', //two-way binding
        month: '=?',
        year: '=?',
        containerForm: '=?', //two-way binding
        editionMode: '<?',
        fullContent: '<?',
        formId: '=',
        isPaymentForm: '<?',
        submittedTab: '<?'
    },
    controllerAs: 'uiExpDateCtrl',
    templateUrl: ['$rootScope', ($rootScope: CommonsRootScope) => {
        return `${$rootScope.routes.templates}ib-ui-expiry-dates-select.html`;
    }]
}, ['CommonsConstants', '$scope'], [])
class ibUiExpiryDatesController implements ng.IController {

    public actualDate: Date;
    public actualMonth: number;
    public availableDays: string[];
    public availableMonths: string[];
    public availableYears: number[];
    public day;
    public month;
    public year;
    public containerForm;
    public maximunYears;
    public showDay;
    public isPaymentForm : boolean | undefined;
    public submittedTab: boolean | undefined;

    constructor (private CommonsConstants: CommonsConstantsType, private $scope: ng.IScope) {
    }


    /**
     * Initialize component availableYears depending on input component binding maximumYears
     * @param {int} maximumYears - the number of years since today's year to start the availableYears array
     * @returns {Array<String>} - the availableYears to select in the view
     */
    initializeYears = (): number[] => {
        let index: number, currentYear: number;
        const yearsArray: number[] = [];
        currentYear = new Date().getFullYear();
        const maxYears: number = currentYear + this.CommonsConstants.PMT_DEFAULT_TO_YEARS;
        for (index = currentYear; index < maxYears; index++) {
            yearsArray.push(currentYear);
            currentYear++;
        }
        return yearsArray;
    };

    /**
     * Throws an event to parent controller. The event will be an object with the day, month and year properties
     */
    throwSelectedDateEvent = (): void => {
        const emitDate = this.showDay ? { day: this.day, month: this.month, year: this.year } : { month: this.month, year: this.year };
        this.$scope.$emit('dateSelected', emitDate);
    };


    /**
     * @name updateMonthExpiration
     * @desc Updates year if month is not in the array of months when user change the expiry month
     */
    updateMonthExpiration = (): void => {
        const currentYear: number = this.actualDate.getFullYear();
        this.availableDays = this.month ? this.getDaysOfMonth(parseInt(this.month), parseInt(this.year ? this.year : this.availableYears[0]), false) : this.CommonsConstants.DAYS_ARRAY.slice();
        if (this.month < this.actualMonth && this.year + '' === currentYear + '') {
            this.year = (currentYear + 1) + '';
        }
        if(this.availableDays[this.availableDays.length-1]<this.day) {
            this.day=this.availableDays[this.availableDays.length-1];
        }
        this.throwSelectedDateEvent();
    };

    /**
     * returns the array of months from input year and input month
     * @returns {Array<String>} - returns the array of days from input year and input month
     */
    getMonthsofYear = (): string[] => {
        const date: Date = new Date();
        return this.CommonsConstants.MONTH_ARRAY.slice().splice(date.getMonth(), this.CommonsConstants.MONTH_ARRAY.length - 1);
    };

    /**
         * returns the array of days from input year and input month
         * @param {int} month - the month which we want to get the days
         * @param {int} year - the month which we want to get the days
         * @param {boolean} modifyOriginDay - true when is neccesary recalculate first available day
         * @returns {Array<String>} - returns the array of days from input year and input month
         */
    getDaysOfMonth = (month, year, modifyOriginDay) => {
        const date: Date = new Date();
        date.setFullYear(year, month, 0);
        //Copy array of days and return only the days of month
        return this.CommonsConstants.DAYS_ARRAY.slice().splice(modifyOriginDay ? (this.actualDate.getUTCDate() - 1) : 0, date.getUTCDate());
    };

    /**
     * @name updateExpiration
     * @desc Updates month and array of months when user change the expiry year
     */
    updateYearExpiration = (): void => {
        const currentYear: number = this.actualDate.getFullYear();
        this.availableDays = this.CommonsConstants.DAYS_ARRAY.slice();
        this.availableMonths = this.CommonsConstants.MONTH_ARRAY.slice();
        if (this.month < this.actualMonth && this.year + '' === currentYear + '') {
            this.month = this.availableMonths[this.actualMonth - 1];
            this.day = this.availableDays[this.actualDate.getUTCDate() - 1];
            this.availableMonths = this.getMonthsofYear();
            this.availableDays = this.getDaysOfMonth(parseInt(this.month), parseInt(this.year ? this.year : this.availableYears[0]), true);
        }
        this.throwSelectedDateEvent();
    };

    daysSelected = ():void => {
        this.throwSelectedDateEvent();
    };





    activate = (): any => {
        this.actualDate = new Date();
        this.actualMonth = this.actualDate.getMonth() + 1;
        this.availableDays = this.CommonsConstants.DAYS_ARRAY.slice();
        this.availableYears = this.initializeYears();
        this.availableMonths = this.CommonsConstants.MONTH_ARRAY.slice();
    };

    $onInit = this.activate();

}